import { FlexProps } from '../../layout/Flex';
import type { ContentPromotionPostsDialogProps } from '../ContentPromotionPostsDialog/types';

export interface ContentPromotionPostsProps extends ContentPromotionPostsDialogProps, FlexProps {
    visiblePostsDialog?: boolean;
    value?: ContentPromotionPostsValue;
    onChange: (value?: ContentPromotionPostsValue) => void;
}

export enum ContentPromotionPostsValue {
    ALL = 'all',
    NEW = 'new',
    CHOICE = 'choice',
}
